import { FunctionComponent } from "react";

import { useTranslation } from "react-i18next";

import { faDatabase } from "@fortawesome/pro-regular-svg-icons";

import { CrmProvider } from "@/pages/Private/redux/crm/crm.schema";
import { crmAddToMenuEntries } from "@/pages/Private/components/AddToCrm/crmAddToMenuEntries";

import { FooterActionItem } from "./FooterActionItem";

interface FooterCrmItemsProps {
	connectedProviders: CrmProvider[];
	onSelectProvider: (provider: CrmProvider) => void;
	onClose: () => void;
}

/**
 * CRM provider menu items for the bulk-action "Add to" group. Only the CRM
 * providers the company has actually connected are listed — a CRM that isn't
 * connected can't receive prospects, so it is not offered. Renders nothing
 * when no provider is connected.
 */
export const FooterCrmItems: FunctionComponent<FooterCrmItemsProps> = ({
	connectedProviders,
	onSelectProvider,
	onClose,
}) => {
	const { t } = useTranslation();

	return (
		<>
			{crmAddToMenuEntries(connectedProviders, t).map(({ provider, label }) => (
				<FooterActionItem
					key={provider}
					icon={faDatabase}
					isMenuItem
					label={label}
					onClick={() => {
						onSelectProvider(provider);
						onClose();
					}}
				/>
			))}
		</>
	);
};
